module.exports = __webpack_public_path__ + "static/media/cq_altro_menu b.70997ae7.svg";